import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CookieState {
  analytics: number;
  preference: number;
  privacy: number;
}

const initialState: CookieState = {
  analytics: localStorage.getItem("cookieAnalytics")
    ? +localStorage.getItem("cookieAnalytics")!
    : 0,
  preference: localStorage.getItem("cookiePreference")
    ? +localStorage.getItem("cookiePreference")!
    : 0,
  privacy: localStorage.getItem("cookiePrivacy")
    ? +localStorage.getItem("cookiePrivacy")!
    : 0,
};

const cookieSlice = createSlice({
  name: "cookie",
  initialState,
  reducers: {
    setAnalytics(state, action: PayloadAction<number>) {
      state.analytics = action.payload;
      localStorage.setItem("cookieAnalytics", action.payload.toString());
    },
    setPreference(state, action: PayloadAction<number>) {
      state.preference = action.payload;
      localStorage.setItem("cookiePreference", action.payload.toString());
    },
    setPrivacy(state, action: PayloadAction<number>) {
      state.privacy = action.payload;
      localStorage.setItem("cookiePrivacy", action.payload.toString());
    },
  },
});

export const { setAnalytics, setPreference, setPrivacy } = cookieSlice.actions;

export default cookieSlice.reducer;
